<div class="tab-section">
  <div class="info-layout">
    <section class="section-block identity-card">
      <header class="section-heading">
        <span class="section-heading-icon"><i class="ri-building-2-line"></i></span>
        <div>
          <span class="section-kicker">Dados gerais</span>
          <h2>Identificação do posto</h2>
          <p>Informação principal, localização e vínculo operacional.</p>
        </div>
      </header>

      <div class="info-grid">
        <div class="info-item has-divider">
          <span class="info-label">Código</span>
          <span class="info-value mono">{{ posto.codigo || 'Não informado' }}</span>
        </div>
        <div class="info-item">
          <span class="info-label">Nome</span>
          <span class="info-value">{{ posto.nome || 'Não informado' }}</span>
        </div>
        <div class="info-item has-divider">
          <span class="info-label">Tipo</span>
          <span class="info-value">{{ posto.tipoPosto?.designacao || posto.nomeTipoPosto || 'Não informado' }}</span>
        </div>
        <div class="info-item">
          <span class="info-label">Cliente</span>
          <span class="info-value">{{ posto.nomeCliente || 'Não informado' }}</span>
        </div>
        <div class="info-item has-divider">
          <span class="info-label">Município</span>
          <span class="info-value">{{ posto.nomeMunicipio || 'Não informado' }}</span>
        </div>
        <div class="info-item">
          <span class="info-label">Província</span>
          <span class="info-value">{{ posto.nomeProvincia || 'Não informada' }}</span>
        </div>
        <div class="info-item has-divider info-item-wide">
          <span class="info-label">Endereço</span>
          <span class="info-value">{{ posto.endereco || 'Não informado' }}</span>
        </div>
        <div class="info-item info-item-wide">
          <span class="info-label">Coordenadas</span>
          <span class="info-value">
            {{ posto.latitude ?? '—' }}, {{ posto.longitude ?? '—' }}
          </span>
        </div>
      </div>
    </section>

    <div class="info-sidebar">
      <section class="section-block operation-card">
        <header class="section-heading compact">
          <span class="section-heading-icon"><i class="ri-settings-3-line"></i></span>
          <div>
            <span class="section-kicker">Operação</span>
            <h2>Configuração do posto</h2>
          </div>
        </header>

        <div class="operation-metrics">
          <div class="operation-metric">
            <span class="metric-icon"><i class="ri-user-line"></i></span>
            <div>
              <strong>{{ posto.numEfetivosTurno ?? 0 }}</strong>
              <span>Efetivos por turno</span>
            </div>
          </div>
          <div class="operation-metric">
            <span class="metric-icon"><i class="ri-time-line"></i></span>
            <div>
              <strong>{{ posto.numTurnosDia ?? 0 }}</strong>
              <span>Turnos por dia</span>
            </div>
          </div>
        </div>

      </section>

      <section class="section-block instructions-card" [class.is-empty]="!posto.instrucoesEspeciais">
        <header class="section-heading compact">
          <span class="section-heading-icon"><i class="ri-file-list-3-line"></i></span>
          <div>
            <span class="section-kicker">Orientações</span>
            <h2>Instruções especiais</h2>
          </div>
        </header>
        <p class="instructions-text" *ngIf="posto.instrucoesEspeciais; else noInstructions">
          {{ posto.instrucoesEspeciais }}
        </p>
        <ng-template #noInstructions>
          <div class="instructions-empty">
            <i class="ri-information-line"></i>
            <span>Nenhuma instrução especial definida para este posto.</span>
          </div>
        </ng-template>
      </section>

      <section class="section-block instructions-card" [class.is-empty]="!posto.descricaoTecnica">
        <header class="section-heading compact">
          <span class="section-heading-icon"><i class="ri-file-info-line"></i></span>
          <div>
            <span class="section-kicker">Descrição</span>
            <h2>Descrição técnica</h2>
          </div>
        </header>
        <p class="instructions-text" *ngIf="posto.descricaoTecnica; else noTechnicalDescription">
          {{ posto.descricaoTecnica }}
        </p>
        <ng-template #noTechnicalDescription>
          <div class="instructions-empty">
            <i class="ri-information-line"></i>
            <span>Nenhuma descrição técnica definida para este posto.</span>
          </div>
        </ng-template>
      </section>
    </div>
  </div>
</div>
